// This function is a stub for the real Drupal.t() function
// It only contains the minimum required functionality to be able to test the
// app without actually being inside a Drupal installation

if (window.Drupal === undefined) {
  window.Drupal = {
    t: (value, variables) => {
      if (variables) {
        Object.keys(variables).map((key) => {
          value = value.replace(key, variables[key]);
          return value;
        });
      }
      return value;
    },
  };
}

export default window.Drupal;
